import React, { useContext } from 'react';
import {
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  useDisclosure,
  Box,
  Text,
  useToast,
} from '@chakra-ui/react';
import { HttpContext } from '../../context/HttpContext';
import { useForm } from 'react-hook-form';
import { getMessage } from '../../util';

export default function CostCategoryRemove({ category, removeCategory }) {
  const toast = useToast();
  const { authAxios } = useContext(HttpContext);
  const { handleSubmit, formState } = useForm();
  const { isSubmitting } = formState;
  const { isOpen, onOpen, onClose } = useDisclosure();

  const onSubmit = async () => {
    try {
      await authAxios.delete(`/cost-categories/${category.id}`);

      toast({
        position: 'top',
        description: `You have successfully disabled "${category.name}" cost category.`,
        status: 'success',
        duration: 6000,
        isClosable: true,
      });
      onClose();
      removeCategory(category);
    } catch (onError) {
      const message = getMessage(onError);
      if (message) {
        toast({
          position: 'top',
          description: message,
          status: 'error',
          duration: 6000,
          isClosable: true,
        });
      }
    }
  };

  return (
    <>
      <Button
        colorScheme="red"
        variant="ghost"
        size="xs"
        fontSize="14px"
        onClick={onOpen}
      >
        Disable
      </Button>

      <Modal isOpen={isOpen} onClose={onClose} size="xl">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader pt="50px" textAlign="center" fontSize="22px">
            Disable cost category?
          </ModalHeader>
          <ModalCloseButton color="#d1d2d2" _focus={{ outline: '0' }} size="sm" />
          <ModalBody pt="10px" pr="30px" pl="30px">
            <Box textAlign="center">
              <Text>
                Are you sure you want to disable{' '}
                <b>
                  {category.name} ({category.code})
                </b>
                ?
              </Text>
              <Text color="#868789" mt="10px" fontSize="14px">
                This cost category will no longer appear in the dropdown when creating
                purchase orders. Existing purchase orders will not be affected.
              </Text>
            </Box>
          </ModalBody>

          <ModalFooter
            d="flex"
            alignItems="center"
            justifyContent="center"
            pt="20px"
            pb="40px"
          >
            <form onSubmit={handleSubmit(onSubmit)}>
              <Button
                colorScheme="red"
                mr={3}
                type="submit"
                disabled={isSubmitting}
                isLoading={isSubmitting}
              >
                Yes, disable
              </Button>
            </form>
            <Button
              variant="outline"
              color="brand.500"
              pt="15px"
              pb="15px"
              onClick={onClose}
              disabled={isSubmitting}
            >
              No, go back
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}
